module.exports = __webpack_public_path__ + "static/media/courseAI.f8037286.svg";